import type { Node } from '@/service/graph'

/**
 * Cytoscape classes for drawing_to_drawing_connector "portal" nodes:
 * 'portal' marks the connector, 'portal-linked' additionally marks ones the
 * backend paired with a sheet (connected_to_graph_id) — tap navigates there.
 */
export function drawingConnectorClasses(node: Node): string {
  if (node.type !== 'symbol') return ''
  const haystack = `${node.category ?? ''} ${node.symbol_type ?? ''} ${node.name ?? ''}`.toLowerCase()
  if (!haystack.includes('drawing_to_drawing_connector')) return ''
  return node.extraProperties?.connected_to_graph_id ? 'portal portal-linked' : 'portal'
}
